import React, { useEffect, useState } from 'react';
import { BASE_URL, USER_URL } from '../../constant/api';
import { BsBoxSeam } from 'react-icons/bs';
import { Link, useNavigate, useParams } from 'react-router-dom';

function SellerOfferView() {
  const navigate = useNavigate();
  const { offerId } = useParams();
  const [offerData, setOfferData] = useState({
    title: "",
    start_date: "",
    end_date: "",
    banner_image: null,
  });
  const [products, setProducts] = useState([]);
  const [existingBannerUrl, setExistingBannerUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // Fetch offer details and products on component load
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch offer details
        const offerResponse = await USER_URL.get(`/products/seller/special-offer/${offerId}/`);
        if (offerResponse.data) {
          const offer = offerResponse.data.Data.special_offer;
          console.log(offer);

          const formatDate = (dateString) => {
            if (!dateString) return "";
            const date = new Date(dateString);
            return isNaN(date.getTime()) ? "" : date.toISOString().split('T')[0];
          };

          setOfferData({
            title: offer.title,
            start_date: formatDate(offer.start_date),
            end_date: formatDate(offer.end_date),
            banner_image: null
          });
          setExistingBannerUrl(offer.banner || "");

          // Handle offer products
          if (Array.isArray(offerResponse.data.Data?.products)) {
            setProducts(offerResponse.data.Data.products);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // alert("Failed to load offer details. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [offerId]);

  return (
    <div>
      <div className="border-2 rounded-lg bg-gray-50 mt-10 p-2">
        <h2 className="text-green-700 text-3xl font-bold text-center mb-6">
          View Offer Details
        </h2>

        {/* Offer Details Section */}
        <div className="flex flex-col sm:flex-row gap-6 mb-6 w-full">
          {/* Image input on the left side */}
          <div className="w-full sm:w-1/2">
            <label className="text-gray-700 font-medium mb-2 block">Banner Image</label>
            <div className="border rounded-md">
              {existingBannerUrl ? (
                <div className="relative">
                  <img
                    src={
                      existingBannerUrl.startsWith(BASE_URL)
                        ? existingBannerUrl
                        : `${BASE_URL}${existingBannerUrl}`
                    }
                    alt="Existing Banner"
                    className="w-full h-44 object-cover rounded-md mb-4"
                  />
                </div>
              ) : (
                <div className="w-full h-40 bg-gray-100 flex items-center justify-center rounded-md text-gray-500 mb-4">
                  No Image Available
                </div>
              )}
            </div>
          </div>

          {/* Offer Details */}
          <div className="w-full sm:w-1/2 flex flex-col gap-6">
            <div className="w-full">
              <label className="text-gray-700 font-medium mb-2 block">Offer Title</label>
              <p className="w-full border p-2 rounded mb-3">{offerData.title}</p>
            </div>

            <div className="w-full">
              <label className="text-gray-700 font-medium mb-2 block">Start Date</label>
              <p className="w-full border p-2 rounded mb-3">{offerData.start_date}</p>
            </div>

            <div className="w-full">
              <label className="text-gray-700 font-medium mb-2 block">End Date</label>
              <p className="w-full border p-2 rounded">{offerData.end_date}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Products Table Section */}
      <div className="overflow-x-auto mb-10">
        {isLoading ? (
          <div className="flex justify-center items-center h-40">
            <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-brand-primary"></div>
            <p className="ml-2">Loading products...</p>
          </div>
        ) : products.length === 0 ? (
          <div className="text-center mt-10">
            <BsBoxSeam className="text-6xl text-gray-400 mx-auto mb-4" />
            <p className="text-lg text-gray-600">No products available</p>
          </div>
        ) : (
          <>
            {/* Table Header */}
            <div className="w-full space-y-4 mt-10">
              <div className="min-w-[800px] grid grid-cols-[4rem,3fr,1.5fr,1.5fr,1fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
                <div className="text-center">Item No</div>
                <div className="text-center">Product Name</div>
                <div className="text-center">Product Code</div>
                <div className="text-center">current discount</div>
                <div className="text-center">Product id</div>
                <div className="text-center">New Discount</div>
                <div className="text-center">View</div>
              </div>
            </div>

            {/* Table Body */}
            {products.map((product, index) => (
              <div key={product.id} className="grid text-[#2F2E41] min-w-[800px] grid-cols-[4rem,3fr,1.5fr,1.5fr,1fr,1fr,1fr,1fr] items-center gap-2 py-2">
                <div className="rounded-xl border p-2 text-center line-clamp-1 hover:line-clamp-none">{index + 1}</div>
                <div className="rounded-xl border p-2 text-center line-clamp-1 hover:line-clamp-none">{product.product_name}</div>
                <div className="rounded-xl border p-2 text-center line-clamp-1 hover:line-clamp-none">{product.product_code}</div>
                <div className="rounded-xl border p-2 text-center line-clamp-1 hover:line-clamp-none">{product.current_discount}</div>
                <div className="rounded-xl border p-2 text-center line-clamp-1 hover:line-clamp-none">{product.id}</div>
                <div className="rounded-xl border p-2 text-center line-clamp-1 hover:line-clamp-none">{`${product.special_discount_percentage}%` || 'N/A'}</div>
                <div className="border p-2 rounded-xl text-center hover:bg-brand-primary text-brand-text-light hover:text-white transition ease-in-out duration-400">
                  <Link to={`/seller/products/view/${product.id}`}>View</Link>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default SellerOfferView;
